import StarRating from './StarRating';
import './Checkbox.css';

function RatingCheckbox({
    id,
    checked,
    onChange
}) {
    function handleChange() {
        onChange?.(!checked)
    }
    // const scores =         [
    //     {
    //         score: 1,
    //         description: "Very dissatisfied. Would not recommend to others."
    //     },
    //     {
    //         score: 2,
    //         description: "Dissatisfied. Unlikely to recommend to others."
    //     },
    //     {
    //         score: 3,
    //         description: "Neutral. Might recommend to others with reservations."
    //     },
    //     {
    //         score: 4,
    //         description: "Satisfied. Would recommend to others."
    //     },
    //     {
    //         score: 5,
    //         description: "Very satisfied. Would enthusiastically recommend to others."
    //     },
    // ]
    const scores = [
        {
          score: 1,
          description: "Very dissatisfied. I deeply regret having this surgery."
        },
        {
          score: 2,
          description: "Dissatisfied. I somewhat regret having this surgery."
        },
        {
          score: 3,
          description: "Neutral. I'm unsure if this surgery was the right decision."
        },
        {
          score: 4,
          description: "Satisfied. I believe this surgery was the right decision for me."
        },
        {
          score: 5,
          description: "Very satisfied. This surgery was one of the best decisions I've ever made."
        },
      ]
    const description = scores[id - 1]?.description
    return (
        <label
            className="checkbox-container"
            style={{fontWeight: 'bold'}}
        >
      <input
        type="checkbox"
        className="checkbox-input"
        checked={checked}
        onChange={handleChange}
      />
      <span
        className={`checkbox-box ${checked ? 'checked' : ''}`}
      />
            <span className={`checkbox-label`} style={{ display: 'flex', alignItems: 'center' }}>
            <StarRating rating={id} className="star-rating checkbox-rating" />
                <span style={{marginLeft: '0.5rem'}}>{description}</span>
            </span>
        </label>
    )
}

export default RatingCheckbox;